export const ENTER_REFERENCE_ID = '1. Enter the reference ID or unique ID for the asset you\'d like to translate captions for.';
export const SELECT_CAPTION = '2. Select the caption you\'d like to translate.';
export const CHOOSE_TARGET_LANGUAGE = '3. Choose the destination language for the caption you\'d like to translate.';
export const FILE_BEING_TRANSLATED = '4. Your file is being translated! It should download to your browser shortly.';
export const AVAILABLE_CAPTIONS = 'Available Captions';
export const CHOOSE_TARGET_LANGUAGE_HEADER = 'Choose Target Language';
export const SUCCESS_TITLE = 'Success!';
export const REFERENCE_ID_LABEL = 'Reference ID or Unique ID';
export const FIND_MY_CAPTIONS = 'Find My Captions';
export const SELECT_BUTTON = 'Select';
export const TRANSLATE_BUTTON = 'Translate';
export const DOWNLOAD_CAPTION = 'Download Caption File';
export const CAPTION_TRANSLATION = 'Caption Translation';
export const RESTART_JOURNEY = 'Start New Translation';
export const REFERENCE_ID_REQUIRED = 'Reference ID is required';
export const REFERENCE_ID_MIN_LENGTH = 'Reference ID must be at least 3 characters long';

// Error messages for API failures
export const ERROR_FIND_CAPTIONS = 'Failed to find captions for the provided reference ID. Please check the ID and try again.';
export const ERROR_SELECT_CAPTION = 'Failed to load caption details. Please try selecting again.';
export const ERROR_TRANSLATE_CAPTION = 'Translation service is currently unavailable. Please try again later.';
export const ERROR_DOWNLOAD_CAPTION = 'Failed to download the caption file. Please try again.';